var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.logo},[(_vm.isTabletLandscapeUp)?_c('svgLogo',{attrs:{"width":"178"}}):_c('svgLogoRound',{attrs:{"width":"30"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }